<div class="ai-topic">
  <app-ai-disclaimer></app-ai-disclaimer>
  <section class="summary-wordcloud">
    @if (aiSummarySelected === "ai-section-selected") {
      <app-interview-ai-appsumm
        [appSumm]="appSumm"
        [isEditing]="isEditing"
        [isLoading]="isLoadingAiSummary"
        (appSummChange)="onSummaryChange($event)"
        class="summary"
      ></app-interview-ai-appsumm>
    }

    @if (aiCategoriesDistributionSelected === "ai-section-selected") {
      <app-interview-ai-nuclear-topic
        class="nuclear-topic-section"
        [nuclearTopicsDistrEnriched]="nuclearTopicsDistrEnriched"
        [isLoading]="isLoadingAiCategoriesDistribution"
      ></app-interview-ai-nuclear-topic>
    }

    @if (aiWordcloudsSelected === "ai-section-selected") {
      <app-interview-ai-wordcloud
        class="wordcloud-section"
        [wordCloudData]="wordCloudData"
        [isLoading]="isLoadingAiWordclouds"
      ></app-interview-ai-wordcloud>
    }

    @if (aiTopicSelected === "ai-section-selected") {
      <app-interview-ai-ai-topic
        class="wordcloud-section"
        [topicsForWordclouds]="topicsForWordclouds"
        [isLoading]="isLoadingAiTopic"
      ></app-interview-ai-ai-topic>
    }
  </section>
</div>
